import {Box, LinkButton, Modal, Typography} from '@yandex-delivery/blocks'
import {useI18n} from '@yandex-delivery/core/i18n'
import {type ReactElement, useCallback} from 'react'

import {EventGoal, useFormUserEventHandler} from '../../../../lib/metrika'
import * as classes from './classes@mobile'
import {useBusinessBannerModal} from './lib/use-business-banner-modal'

export type BusinessModalProps = {
  // мьючу правило, тут уперлось в https://github.com/jsx-eslint/eslint-plugin-react/blob/master/docs/rules/no-unused-prop-types.md#known-issueslimitations
  // eslint-disable-next-line react/no-unused-prop-types
  opened: boolean
  // eslint-disable-next-line react/no-unused-prop-types
  onClose: () => void
  // eslint-disable-next-line react/no-unused-prop-types
  utmSource?: string
}

export function BusinessModal(props: BusinessModalProps): ReactElement {
  const {opened, onClose, title, list, description, imageSrc, link} = useBusinessBannerModal(props)
  const i18n = useI18n()

  const handleReachGoal = useFormUserEventHandler()

  const handleRegisterLinkClick = useCallback(() => {
    handleReachGoal(EventGoal.BannerRegistrationButtonClick)
  }, [handleReachGoal])

  return (
    <Modal className={classes.modal} onClose={onClose} opened={opened}>
      <Modal.Header pb="s" pt="xl" />
      <Modal.Body className={classes.body}>
        <Typography color="invert" group="normal" mb="m" thickness="bold" variant="title3">
          {title}
        </Typography>
        <Typography color="invert" Component="div" group="loose" variant="body2">
          {description}
        </Typography>
        {list.length > 0 ? (
          <Typography color="invert" Component="div" group="loose" ml="xl" mt="m" variant="body2">
            <ul>
              {list.map((text, i) => (
                <li key={`business-banner-point-${i}`}>{text}</li>
              ))}
            </ul>
          </Typography>
        ) : null}
        <Box className={classes.image} mt="m" style={{backgroundImage: `url(${imageSrc})`}} />
      </Modal.Body>
      <Modal.Footer className={classes.footer}>
        <LinkButton href={link} onPress={handleRegisterLinkClick} variant="floating" fullWidth>
          {i18n('order.banner.button.register', 'Зарегистрироваться')}
        </LinkButton>
      </Modal.Footer>
    </Modal>
  )
}
